<script>
export default {
    name: "OrdersIndex",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500
                 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {
        "orders-tab": () => import('./tabs/Orders.vue'),
        "transfers-tab": () => import('./tabs/Transfers.vue'),
        'transfer-request-form': () => import('./modals/TransferRequest.vue'),
        'order-form': () => import('./modals/Order.vue'),
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
                <template v-slot:card-header>
                    <div class="w-full flex flex-wrap">
                        <div class="flex-1">
                            <h5 class="text-sm font-medium">Inventory: Orders</h5>
                        </div>
                        <div class="w-1/4 text-right p-1">
                            <button 
                                @click.prevent="$router.push({name: ``, query: { initiateTR: 1, }})"
                                class="btn-sm btn-info text-xs rounded mr-3">
                                Transfer Request
                            </button>
                            <button 
                                @click.prevent="$router.push({name: ``, query: { active: 1, }})"
                                class="btn-sm btn-info text-xs rounded">Create Order
                            </button>
                        </div>
                    </div>
                    <order-form 
                        :showModal="$route.query.active ? true : false"
                        @refresh="$refs.ordersTab.fetchOrders()"
                        @closeModal="$router.push({ 
                            name: `inventory-management.orders.index`, 
                        })"
                    />
                    <transfer-request-form 
                        :showModal="$route.query.initiateTR ? true : false"
                        @refresh="$refs.transfersTab.fetchTransfers()"
                        @closeModal="$router.push({ 
                            name: `inventory-management.orders.index`, 
                        })"
                    />
                </template>
                <template v-slot:card-body>
                    <ul class="w-full flex border-b-2 border-gray-500">
                        <li class="-mb-px mr-1">
                            <a href="javascript:void(0)" @click.prevent="active=0"
                              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                                px-4 font-medium whitespace-no-wrap"
                              :class="active == 0 ? activeClass : inActiveClass">
                              Orders</a>
                        </li>
                        <li class="-mb-px mr-1">
                            <a href="javascript:void(0)" @click.prevent="active=1"
                              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                                px-4 font-medium whitespace-no-wrap"
                              :class="active == 1 ? activeClass : inActiveClass">
                              Transfer Requests</a>
                        </li>
                    </ul>
                    <orders-tab ref="ordersTab" v-if="active == 0" />
                    <transfers-tab ref="transfersTab" v-if="active == 1" />
                </template>
                <template v-slot:card-footer>
                    <div class="w-full text-right">
                         <router-link 
                            :to="{ name: `inventory-management.index`, }" 
                            class="btn-sm btn-danger text-xs rounded">
                               <i class="fa fa-caret-left"></i> Back</router-link>
                    </div>
                </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
<style scoped>
.h-30 {
    min-height: 20rem;
    max-height: 30rem;
}
@media print {
    .h-30 {
        max-height: none;
    }
}
</style>
